import { render } from "./searchAutosuggestBox.vue?vue&type=template&id=983da2d6"
import script from "./searchAutosuggestBox.vue?vue&type=script&lang=js"
export * from "./searchAutosuggestBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__